import { TerminalSquare } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { sandboxShellWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  sandboxShellWeb,
  {
    SandboxShellTab: () => import('./SandboxShellTab'),
    SandboxShellTabPreview: () => import('./SandboxShellTabPreview'),
  },
  {
    icons: { TerminalSquare },
  },
);
